export default __webpack_public_path__ + "static/media/splash-screen-1.6fabef71.png";